import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const CTASection = () => {
  return (
    <section data-testid="cta-section" className="section-padding bg-its-teal relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-its-gold rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-its-teal-light rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="section-container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="glass-card text-center py-12 md:py-16"
        >
          <h2 className="heading-2 mb-4">Ready to Get Started?</h2>
          <p className="body-text max-w-2xl mx-auto mb-8">
            Let's discuss your project and create something amazing together.
            Our process is designed to understand your needs and deliver
            results.
          </p>
          <Link
            to="/process"
            data-testid="cta-start-project"
            className="btn-primary inline-flex"
          >
            Start Your Project
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
